import type { ImageInput, OcrConfiguration } from '../types';
import { PerformOcrResult, handleImageInput, withSBErrorHandling } from '../types';

import { ScanbotSDKPlugin } from './Definitions';

/**
 * @internal
 * @hidden
 */
export const ScanbotOcrEngineImpl = {
  async recognizeOnImages(params: {
    images: ImageInput[];
    configuration?: OcrConfiguration;
  }): Promise<PerformOcrResult> {
    return withSBErrorHandling(
      async () =>
        new PerformOcrResult(
          await ScanbotSDKPlugin.recognizeOcrOnImages({
            configuration: params.configuration,
            images: handleImageInput(params.images),
          }),
        ),
    );
  },

  async recognizeOnDocument(params: {
    documentUuid: string;
    configuration?: OcrConfiguration;
  }): Promise<PerformOcrResult> {
    return withSBErrorHandling(async () => new PerformOcrResult(await ScanbotSDKPlugin.recognizeOcrOnDocument(params)));
  },
};
